import { useQuery } from "@tanstack/react-query";

import { ListPrescribersQueryFilters, UseListPrescribersQueryOptions } from "./types";
import { getPrescribersService } from "./service";

export const listPrescribersQueryKey = ["prescriber_admin"];

export function useListPrescribersQuery(
  filters?: ListPrescribersQueryFilters,
  options?: UseListPrescribersQueryOptions
) {
  const queryKey = listPrescribersQueryKey.concat(JSON.stringify(filters));

  return useQuery({
    queryKey,
    queryFn: async () => getPrescribersService(filters),
    ...options,
  });
}
